module.exports = __webpack_public_path__ + "img/kids-2.e31c0f98.webp";